export default __webpack_public_path__ + "static/media/promo_07.934d25c7.jpg";